import { useEffect, useRef } from "react";

const useMessageList = ({ messages = [], score, waiting }) => {
  const messageEndRef = useRef(null);

  const scrollToBottom = () => {
    messageEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [waiting]);

  useEffect(() => {
    scrollToBottom();
  }, [messages.length]);

  useEffect(() => {
    if (score?.scores?.length > 0) {
      scrollToBottom();
    }
  }, [score?.scores?.length]);

  useEffect(() => {
    const handleResize = () => {
      scrollToBottom();
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { messageEndRef };
};

export default useMessageList;
